// @ts-check
import BlockCard from '../BlockCard';

/** Horizontal funnel bars (width relative to the largest step count) with the worst drop-off step called out. */
export default function FunnelBlock({ block }) {
  const { steps = [], worst_drop_step: worst = null } = block.data || {};
  const max = Math.max(0, ...steps.map((s) => s.count));

  return (
    <BlockCard title="Funnel" href={block.href} headline={block.headline}>
      {max === 0 ? (
        <p className="text-sm text-muted-foreground">No traffic in this range</p>
      ) : (
        <>
          <ul className="space-y-2">
            {steps.map((s) => (
              <li key={s.key} data-testid="funnel-step" className="text-sm">
                <div className="flex items-center justify-between">
                  <span>{s.label}</span>
                  <span className="font-medium">{s.count}</span>
                </div>
                <div className="mt-1 h-2 rounded bg-muted">
                  <div data-testid="funnel-bar" className="h-2 rounded bg-primary" style={{ width: `${(s.count / max) * 100}%` }} />
                </div>
              </li>
            ))}
          </ul>
          {worst && (
            <p className="mt-3 text-sm text-muted-foreground" data-testid="funnel-worst">
              Biggest drop-off: <span className="font-semibold text-foreground">{worst}</span>
            </p>
          )}
        </>
      )}
    </BlockCard>
  );
}
